import React from 'react'
import PropTypes from 'prop-types'
import TrackingLink from '../../../../functional-components/TrackingLink'
import { FLOW_TYPES, ORIGINS } from '../../../../data-tagging/constants'
import './index.css'

const SocialButton = ({ href, alt, imgSrc, isLast }) => (
  <TrackingLink
    className={`social-button${isLast ? ' social-button--last' : ''}`}
    href={href}
    target="_blank"
    sectionName="social_button_link"
    flowType={FLOW_TYPES.FOOTER}
    origin={ORIGINS.FOOTER}
    sectionItem={alt}
  >
    <img alt={alt} src={imgSrc} width={18} />
  </TrackingLink>
)

SocialButton.defaultProps = {
  isLast: false,
}

SocialButton.propTypes = {
  href: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  imgSrc: PropTypes.string.isRequired,
  isLast: PropTypes.bool,
}

export default SocialButton
